/* Everfête plush cursor: a Santa-hat Snow Bun follows the mouse; after a short pause with no moving or scrolling it hops and spins.
   Desktop mouse only. Text fields keep the normal caret. Reduced-motion users get the plush without the idle tricks. */
(function () {
  if (window.__efCursor) return; window.__efCursor = true;
  if (!window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (window.Shopify && Shopify.designMode) return;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var IDLE_MS = 900, TYPE = 'input,textarea,select,[contenteditable=""],[contenteditable="true"],iframe';
  var HOT = 'a,button,summary,label,[role="button"],[role="tab"],[role="option"],input[type="submit"],input[type="button"],input[type="radio"],input[type="checkbox"],input[type="range"],.door,.chip,swatch-component';

  var css = 'html.ef-cur,html.ef-cur *{cursor:none!important}'
    + 'html.ef-cur input:not([type=range]):not([type=checkbox]):not([type=radio]):not([type=submit]):not([type=button]),html.ef-cur textarea,html.ef-cur select,html.ef-cur [contenteditable=""],html.ef-cur [contenteditable="true"]{cursor:text!important}'
    + '#ef-cursor{position:fixed;left:0;top:0;width:54px;height:54px;pointer-events:none;z-index:2147483647;opacity:0;will-change:transform;transition:opacity .15s}'
    + '#ef-cursor.on{opacity:1}'
    + '#ef-cursor .h{width:100%;height:100%;transform-origin:4px 4px;transition:transform .18s cubic-bezier(.3,1.6,.5,1)}'
    + '#ef-cursor.hot .h{transform:scale(1.18) rotate(-10deg)}#ef-cursor.down .h{transform:scale(.88,.8)}'
    + '#ef-cursor .b{width:100%;height:100%;transform-origin:60% 62%}'
    + '#ef-cursor svg{display:block;width:100%;height:100%;overflow:visible;filter:drop-shadow(0 2px 2px rgba(59,43,39,.25))}'
    + '#ef-cursor.idle .b{animation:efhop 2.6s cubic-bezier(.45,0,.3,1) infinite}'
    + '@keyframes efhop{'
    + '0%{transform:translateY(0) rotate(0) rotateY(0) scale(1,1)}'
    + '10%{transform:translateY(-12px) rotate(0) rotateY(0) scale(.94,1.07)}'
    + '20%{transform:translateY(0) rotate(0) rotateY(0) scale(1.1,.9)}'
    + '27%{transform:translateY(0) rotate(0) rotateY(0) scale(1,1)}'
    + '42%{transform:translateY(-16px) rotate(180deg) rotateY(0) scale(1,1)}'
    + '56%{transform:translateY(0) rotate(360deg) rotateY(0) scale(1.1,.9)}'
    + '63%{transform:translateY(0) rotate(360deg) rotateY(0) scale(1,1)}'
    + '78%{transform:translateY(-12px) rotate(360deg) rotateY(180deg) scale(1,1)}'
    + '90%{transform:translateY(0) rotate(360deg) rotateY(360deg) scale(1.06,.94)}'
    + '100%{transform:translateY(0) rotate(360deg) rotateY(360deg) scale(1,1)}}'
    + (reduce ? '#ef-cursor .h{transition:none}#ef-cursor.idle .b{animation:none}' : '');
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  /* tip at 0,0 is the click point; the bun sits just below-right of it */
  var svg = '<svg viewBox="0 0 48 48" aria-hidden="true">'
    + '<path d="M1.5 1.5 L13 5.5 L5.5 13 Z" fill="#C0394B" stroke="#fff" stroke-width="1.5" stroke-linejoin="round"/>'
    + '<g transform="translate(7 6) scale(.44)">'
    + '<path d="M10 70 Q10 38 50 33 Q90 38 90 70 Q90 88 50 88 Q10 88 10 70Z" fill="#FFF4E4" stroke="#E6C9B3" stroke-width="3"/>'
    + '<path d="M40 36 Q50 20 60 36Z" fill="#FFF4E4" stroke="#E6C9B3" stroke-width="3"/>'
    + '<path d="M30 40 Q48 4 74 22 L66 40Z" fill="#C0394B"/><rect x="26" y="36" width="50" height="9" rx="4.5" fill="#fff" stroke="#EBDDD2" stroke-width="2"/><circle cx="76" cy="21" r="6" fill="#fff" stroke="#EBDDD2" stroke-width="2"/>'
    + '<circle cx="39" cy="63" r="4.2" fill="#3B2B27"/><circle cx="61" cy="63" r="4.2" fill="#3B2B27"/><circle cx="40.4" cy="61.6" r="1.3" fill="#fff"/><circle cx="62.4" cy="61.6" r="1.3" fill="#fff"/>'
    + '<path d="M45 70 Q50 75 55 70" stroke="#3B2B27" stroke-width="2.6" fill="none" stroke-linecap="round"/>'
    + '<ellipse cx="29" cy="71" rx="6" ry="3.6" fill="#F29AAE" opacity=".75"/><ellipse cx="71" cy="71" rx="6" ry="3.6" fill="#F29AAE" opacity=".75"/>'
    + '</g></svg>';

  var el = document.createElement('div'); el.id = 'ef-cursor'; el.setAttribute('aria-hidden', 'true');
  el.innerHTML = '<div class="h"><div class="b">' + svg + '</div></div>';

  var x = -100, y = -100, raf = 0, timer = 0;
  function place() { raf = 0; el.style.transform = 'translate3d(' + (x - 2) + 'px,' + (y - 2) + 'px,0)'; }
  function wake() { el.classList.remove('idle'); clearTimeout(timer); timer = setTimeout(function () { el.classList.add('idle'); }, IDLE_MS); }

  function start() {
    document.body.appendChild(el);
    document.documentElement.classList.add('ef-cur');
    document.addEventListener('mousemove', function (e) {
      x = e.clientX; y = e.clientY; if (!raf) raf = requestAnimationFrame(place);
      var t = e.target && e.target.closest ? e.target : null;
      var typing = t && t.closest(TYPE);
      el.classList.toggle('on', !typing);
      el.classList.toggle('hot', !!(t && !typing && t.closest(HOT)));
      wake();
    }, { passive: true });
    window.addEventListener('scroll', wake, { passive: true, capture: true });
    window.addEventListener('wheel', wake, { passive: true });
    document.addEventListener('mousedown', function () { el.classList.add('down'); wake(); });
    document.addEventListener('mouseup', function () { el.classList.remove('down'); });
    document.documentElement.addEventListener('mouseleave', function () { el.classList.remove('on'); });
    window.addEventListener('blur', function () { el.classList.remove('on'); });
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
